'use strict'

import TypesenseError from './TypesenseError'

export default class RequestUnauthorized extends TypesenseError {}
